/**
 * 大玩家接口
 * 
 * @author 杨斌
 * @since 2019-09-24
 */
import common from './common'
import store from './store'

var ApiList = {};

//API 接口

/**
 * easy用户 实物商品下单
 * @param {*} addressId  地址 id，订单是京东实物时传京东地址
 * @param {*} feeList  费用列表，把结算页里的 feeList 按 'type:point,type:point' 的格式传回来
 * @param {*} payPoint  支付费用，传结算页里的需支付费用
 * @param {*} skuType  订单类型
 * @param {*} skus  商品列表，格式为 skuId:num,skuId:num
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.easyOrderTake = function (addressId, feeList, payPoint, skuType, skus, okCb, failCb) {
    var p = {
        addressId,
        feeList,
        payPoint,
        skuType,
        skus
    }
    common.Api('/customer/api/easyOrder/take.json', p, okCb, failCb)
}

/**
 * easy用户 虚拟商品下单
 * @param {*} addressId  地址 id，订单是京东实物时传京东地址
 * @param {*} feeList  费用列表，把结算页里的 feeList 按 'type:point,type:point' 的格式传回来
 * @param {*} payPoint  支付费用，传结算页里的需支付费用
 * @param {*} skuType  订单类型
 * @param {*} skus  商品列表，格式为 skuId:num,skuId:num
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.easyOrderTakeVmall = function (pricePoint, skuId, okCb, failCb) {
    var p = {
        pricePoint,
        skuId,
    }
    common.Api('/customer/api/easyOrder/takeVmall.json', p, okCb, failCb)
}

/**
 * easy用户 黄金商品下单
 * @param {*} addressId  地址 id，订单是京东实物时传京东地址
 * @param {*} feeList  费用列表，把结算页里的 feeList 按 'type:point,type:point' 的格式传回来
 * @param {*} payPoint  支付费用，传结算页里的需支付费用
 * @param {*} skuType  订单类型
 * @param {*} skus  商品列表，格式为 skuId:num,skuId:num
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.easyOrderTakeJingdongGold = function (addressId, count, feeList, payPoint, skuId, okCb, failCb) {
    var p = {
        addressId,
        count,
        feeList,
        payPoint,
        skuId,
    }
    common.Api('/customer/api/easyOrder/takeJingdongGold.json', p, okCb, failCb)
}


/**
 * 未确认订单
 */
ApiList.easyOrderUnConfirmed = function (okCb, failCb) {
    var p = {}
    common.Api('/customer/api/easyOrder/unConfirmed.json', p, okCb, failCb)
}

/**
 * 历史订单
 */
ApiList.easyOrderHistorical = function (lastId, limit, unConfirmEasyOrderId, okCb, failCb) {
    var p = {
        lastId,
        limit,
        unConfirmEasyOrderId
    }

    common.Api('/customer/api/easyOrder/historical.json', p, okCb, failCb)
}

/**
 * 取消京东订单
 */
ApiList.easyOrderCancelJD = function (orderno, okCb, failCb) {
    var p = {
        orderno,
    }

    common.Api('/customer/api/easyOrder/cancelJingdong.json', p, okCb, failCb)
}

/**
 * 取消虚拟订单
 */
ApiList.easyOrderCancelVmall = function (orderno, okCb, failCb) {
    var p = {
        orderno,
    }

    common.Api('/customer/api/easyOrder/cancelVmall.json', p, okCb, failCb)
}

export default ApiList;


// WEBPACK FOOTER //
// ./src/api/easy-api.js